var ModalView = require('../../js/components/ModalView'),
  activateResendTemplate = require('../Login/templates/_ResendEmailSuccessModal.hbs'),
  ActivateResendModalView,
  ActivateResendModalView = ModalView.extend({
    template: activateResendTemplate,
    remodal: { closeOnOutsideClick: false },
    events: {
      'click #success-button': 'onClose'
    },
    initialize: function() {
      ActivateResendModalView.__super__.initialize.apply(this, arguments);
      this.open();
    },
    initializeElements: function() {
      this.$firstElement = this.$('.Modal-close.Icon.Icon--cross');
      this.$lastElement = this.$('#success-button');
      this.$modalContainer = this.$('.Modal-dialog.ForgotPassword-modal');
    },
    open: function() {
      this.render();
      this.modal.open();
    },
    onOpen: function() {
      this.initializeElements();
      this.$modalContainer.attr('aria-modal', true);
      this.$modalContainer.attr('aria-describedby', 'resendEmail-success-message');
      this.$modalContainer.focus();
      this.$firstElement.attr('role', 'button');
      this.$firstElement.on('keydown', (e) => {
        if (e.key === 'Tab' && e.shiftKey) {
          e.preventDefault();
          this.$lastElement.focus();
        }
      });
      this.$lastElement.on('keydown', (e) => {
        if (e.key === 'Tab' && !e.shiftKey) {
          e.preventDefault();
          this.$firstElement.focus();
        }
      });
    },
    onClose: function onClose(e) {
      e.preventDefault();
      this.$modalContainer.removeAttr('aria-modal');
    }
  });
module.exports = ActivateResendModalView;



// WEBPACK FOOTER //
// ./assets/components/Login/ActivateResendModal.js